import { render, staticRenderFns } from "./seoBoard.vue?vue&type=template&id=f1ceb8da&scoped=true"
import script from "./seoBoard.vue?vue&type=script&lang=js"
export * from "./seoBoard.vue?vue&type=script&lang=js"
import style0 from "./seoBoard.vue?vue&type=style&index=0&id=f1ceb8da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ceb8da",
  null
  
)

export default component.exports